import React from 'react';
import '../Style/SystemServices.css'; // ✅ Ensure this CSS file exists

const SystemServices = () => {
  return (
    <div className="systemservices-container">
      <div className="systemservices-text">
        <h2>System/Box Build</h2>
        <p>
       At Automotive Devices, we provide end-to-end box build assembly services designed to streamline your product’s journey from concept to delivery. Our comprehensive solutions cover everything from PCB assembly and cable harnessing to enclosure integration and final system testing, ensuring that every component of your product is perfectly aligned for peak performance. Whether you're looking for a simple enclosure assembly or a more complex electromechanical system, our experienced team works with precision and attention to detail to meet your exact requirements.

We offer the flexibility to handle low- to high-volume production runs, and our efficient processes ensure on-time delivery of fully assembled and tested products. With a focus on quality control, functionality testing, and custom packaging, we ensure that your product is ready for market, straight out of the box. Let Automotive Devices be your trusted partner for complete box build solutions, delivering a finished product that meets the highest industry standard
        </p>
      </div>

      <div className="systemservices-image">
        <img src="/images (2).jpeg" alt="System Integration Services" />
      </div>
    </div>
  );
};

export default SystemServices;
